import React from "react";
import CenteredContentWrapper from '../elements/CenteredContentWrapper';

export default class SuperCharged extends React.PureComponent {
    render() {
        return (
            <div className={'top-double-block super-charged-macro-control'}>
                <CenteredContentWrapper className={'wrapper'}>
                    <div className={'text-block'}>
                        <div className={'inner'}>
                            <div className={'title'}>Super charged<br/>macro Controls</div>
                            <div className={'description'}>
                                Sound design is only a few clicks away<br/>
                                Customize your sound using our powerful set of macro controls
                                <div className={'breaker'}></div>
                                Every sound has a custom set of 8 macro controls
                            </div>
                        </div>
                    </div>
                    <img alt={'Super charged macro Controls'} className={'mobile-element'} src={require('../../assets/images/landing/super-charged-macro-control-original.webp')}/>
                </CenteredContentWrapper>
            </div>
        );
    }
}
